import React from 'react';
import SideNavItem from 'factory/sidenav/components/SideNavItem';
import AddonsSideNavItem from 'factory/sidenav/components/AddonsSideNavItem';
import SideNavContent from 'factory/sidenav/components/SideNavContent';

export interface AdminAddonSideNavProps {
  path: string;
}

const adminAddonSideNav: React.FC<AdminAddonSideNavProps> = (
  props
) => {
  const { path } = props;

  return (
    <div>
      <ul className="navigation navigation--light">
        <AddonsSideNavItem />
      </ul>
      <SideNavContent path={path}>
        <SideNavItem
          link="/addons"
          icon="Events"
          label="adminAddon.managePermissions.title"
        />
        <SideNavItem
          link="/analytics"
          icon="Dashboard"
          label="analyticsAddon.title"
        />
        <SideNavItem
            submenuIcon="Cog"
            submenuLabel="administration"
            label="administration"
            link="/settings"
            icon="Cog"
          >
            <ul className="navigation">
              <SideNavItem
                submenuIcon="Cog"
                submenuLabel="clients"
                label="clients"
                link="/settings/clients"
                icon="person"
              />
              <SideNavItem
              submenuIcon="Cog"
              submenuLabel="users"
              label="users"
              link="/settings/users"
              icon="person"
              />
            </ul>
          </SideNavItem>
      </SideNavContent>
    </div>
  );
};

export default adminAddonSideNav;
